import { Injectable } from '@angular/core';

import { FixturePage } from '@cds/betting-offer';
import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { groupBy, keys, orderBy } from 'lodash-es';

import { GroupedEvents } from '../../event-details-common/event-details-common.models';
import { getLeagueId } from '../../event-details-common/event-details-common.utils';

@Injectable({ providedIn: 'root' })
export class NavigationEventMapperService {
    constructor(protected fixtureFactory: FixtureFactory) {}

    mapFixtures(page: FixturePage | undefined): GroupedEvents {
        if (!page) {
            return {};
        }

        const events = page.fixtures.map((f) => this.fixtureFactory.create(f));
        const grouped = groupBy(events, (f) => getLeagueId(f));

        const result: { [leagueId: number]: EventModel[] } = [];
        // Needed because events can have same start date and
        // CDS doesn't provide sorting by name (code) as fallback in this case
        keys(grouped).forEach((key) => {
            result[key as any as number] = orderBy(grouped[key], [
                (e) => (e.live ? 0 : 1),
                (e) => (e.scoreboard.started ? 0 : 1),
                (e) => e.startDate.getTime(),
                (e) => e.participants.map((p) => p.shortName).join(),
            ]);
        });

        return result;
    }
}
